/**
 * Métriques réelles de la grille du dashboard (largeur de cellule / hauteur),
 * capturées sur la grille GridStack vivante et réutilisées par l'aperçu du
 * configurateur pour que la taille affichée corresponde au rendu final.
 *
 * GridStack rend une cellule à `largeurGrille / nbColonnes` (responsive), alors
 * qu'un aperçu avec une largeur de colonne fixe donnerait une taille différente.
 */
export type GridCellMetrics = { cellWidth: number; cellHeight: number };

// Valeurs par défaut si le dashboard n'a pas encore été monté (ex. accès direct
// au configurateur après un rechargement) — approximation desktop raisonnable.
let metrics: GridCellMetrics = { cellWidth: 110, cellHeight: 50 };

export function setGridCellMetrics(next: GridCellMetrics) {
  if (next.cellWidth > 0 && next.cellHeight > 0) metrics = next;
}

export function getGridCellMetrics(): GridCellMetrics {
  return metrics;
}
